import React, { useEffect, useState } from 'react';
import Fieldset from '../fieldset';
import useInitialAppointmentState from './actions/initialAppointmentState';
import { Notification } from './notification';
import { Loader } from './loader';
import { TimeSlotPicker } from './time-slot-picker';
import { formatAppointmentSubmission } from './actions/formatAppointmentSubmission';
import { useTranslation } from '../../contexts/translation-context';
import { useFieldActions } from '../../contexts/field-actions-context';
export function AppointmentField(props) {
  var _appointmentState$sel, _appointmentState$sel2;
  const {
    onBlur,
    onFocus,
    inputId,
    ariaLabelledBy,
    ariaDescribedBy,
    onChange,
    initialData
  } = props;
  const [appointmentState, setAppointmentState] = useState(null);
  const [isReloadingSlots, setIsReloadingSlots] = useState(false);
  const initialAppointmentState = useInitialAppointmentState({
    ...props
  });
  const {
    actions
  } = useFieldActions();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setAppointmentState(initialAppointmentState);
  }, [initialAppointmentState]);
  useEffect(() => {
    const updateAvailabilitySlots = async () => {
      var _initialData$service;
      if (appointmentState != null && appointmentState.selectedDate && initialData != null && (_initialData$service = initialData.service) != null && _initialData$service.id) {
        setIsReloadingSlots(true);
        const availabilitySlotsToUpdate = await (actions == null || actions.getAvailabilitySlots == null ? void 0 : actions.getAvailabilitySlots({
          serviceId: initialData.service.id,
          timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
          selectedDate: appointmentState.selectedDate
        }));
        setAppointmentState({
          ...appointmentState,
          availabilitySlots: availabilitySlotsToUpdate
        });
        setIsReloadingSlots(false);
      }
    };
    updateAvailabilitySlots();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentState == null ? void 0 : appointmentState.selectedDate]);
  useEffect(() => {
    if (onChange) {
      onChange(formatAppointmentSubmission(appointmentState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appointmentState == null || (_appointmentState$sel = appointmentState.selectedSlot) == null || (_appointmentState$sel = _appointmentState$sel.slot) == null ? void 0 : _appointmentState$sel.startDate, appointmentState == null || (_appointmentState$sel2 = appointmentState.selectedSlot) == null || (_appointmentState$sel2 = _appointmentState$sel2.slot) == null ? void 0 : _appointmentState$sel2.endDate, appointmentState == null ? void 0 : appointmentState.timezone]);
  if (appointmentState != null && appointmentState.error) {
    console.error('Error in appointment state', appointmentState.error);
  }
  const renderField = () => {
    if (appointmentState != null && appointmentState.error) {
      return /*#__PURE__*/React.createElement(Notification, {
        message: t('form.appointment.empty-state.notification.text')
      });
    }
    if (!(appointmentState != null && appointmentState.availabilityDates)) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    return /*#__PURE__*/React.createElement(TimeSlotPicker, {
      isReloadingSlots: isReloadingSlots,
      appointmentFieldProps: props,
      appointmentState: appointmentState,
      setAppointmentState: setAppointmentState
    });
  };
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    ariaDescribedBy: ariaDescribedBy,
    required: true
  }, renderField());
}
//# sourceMappingURL=appointment.js.map